import React, { createContext, useContext, useEffect, useMemo, useState } from 'react'
import {
  FALLBACK_PROPERTY_CONDITIONS,
  FALLBACK_PROPERTY_CONDITION_GROUPS,
} from '../constants/propertyConditionFallback'

const API_BASE_URL = 'https://api.realitni-jestrab.cz'
const PropertyMetadataContext = createContext(null)

export const PropertyMetadataProvider = ({ children }) => {
  const [propertyConditions, setPropertyConditions] = useState(FALLBACK_PROPERTY_CONDITIONS)
  const [propertyConditionGroups, setPropertyConditionGroups] = useState(FALLBACK_PROPERTY_CONDITION_GROUPS)

  useEffect(() => {
    let cancelled = false
    fetch(`${API_BASE_URL}/api/metadata/property-options`)
      .then((response) => {
        if (!response.ok) throw new Error(`Metadata request failed: ${response.status}`)
        return response.json()
      })
      .then((metadata) => {
        if (cancelled || !Array.isArray(metadata.propertyConditions) || !metadata.propertyConditions.length) return
        setPropertyConditions(metadata.propertyConditions)
        if (Array.isArray(metadata.propertyConditionGroups) && metadata.propertyConditionGroups.length) {
          setPropertyConditionGroups(metadata.propertyConditionGroups)
        }
      })
      .catch((error) => console.warn('Property metadata fallback is being used:', error))

    return () => {
      cancelled = true
    }
  }, [])

  const value = useMemo(() => {
    const valuationConditions = propertyConditions.filter(({ valuationAllowed }) => valuationAllowed)
    const filterConditions = propertyConditions.filter(({ filterKey }) => filterKey)
    const conditionFilterMap = Object.fromEntries(filterConditions.map(({ value, filterKey }) => [value, filterKey]))
    return { propertyConditions, propertyConditionGroups, valuationConditions, filterConditions, conditionFilterMap }
  }, [propertyConditions, propertyConditionGroups])

  return <PropertyMetadataContext.Provider value={value}>{children}</PropertyMetadataContext.Provider>
}

export const usePropertyMetadata = () => {
  const metadata = useContext(PropertyMetadataContext)
  if (!metadata) throw new Error('usePropertyMetadata must be used inside PropertyMetadataProvider')
  return metadata
}
